import { Button, Chip } from '@mui/material';
import LeaveActions from './LeaveActions';
import WFHTasks from '../../../views/user/EmployeeServices/leave/WFHTasks';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';

export const LEAVE_APPLICATION_TABLE_HEAD = () => {
  const navigate = useNavigate();

  return [
    {
      field: 'serialNumber',
      flex: 0.2,
      minWidth: 90,
      headerName: 'sl.No',
      type: 'number',
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: 'leaveId',
      flex: 1,
      minWidth: 100,
      headerName: 'Leave App. Id',
      type: 'number',
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: 'leaveType',
      flex: 1,
      minWidth: 200,
      headerName: 'Type Of Leave',
      type: 'string',
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: 'fromDate',
      flex: 1,
      minWidth: 200,
      headerName: 'From Date',
      type: 'string',
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: 'toDate',
      flex: 1,
      minWidth: 200,
      headerName: 'To Date',
      type: 'string',
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: 'noOfdays',
      flex: 1,
      minWidth: 200,
      headerName: 'No of Days',
      type: 'string',
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: 'reason',
      flex: 1,
      minWidth: 200,
      headerName: 'Reason',
      type: 'string',
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: 'leaveStatus',
      flex: 1,
      minWidth: 200,
      headerName: 'Status',
      type: 'string',
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: 'hodRemarks',
      flex: 1,
      minWidth: 200,
      headerName: 'Hod Remarks',
      type: 'string',
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: 'hodLastUpdate',
      flex: 1,
      minWidth: 200,
      headerName: 'Last Update by Hod',
      type: 'string',
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: 'hrRemarks',
      flex: 1,
      minWidth: 200,
      headerName: 'HR remarks',
      type: 'string',
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: 'hrLastUpdate',
      flex: 1,
      minWidth: 200,
      headerName: 'Last update by HR',
      type: 'string',
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: 'tasks',
      flex: 1,
      minWidth: 150,
      headerName: 'Task View',
      type: 'string',
      headerAlign: 'left',
      align: 'left',
      renderCell: (params) => {
        if (params.row.leaveType === 'Work From Home (WFH)') {
          return <WFHTasks rowData={params.row} />;
        }
      },
    },
    {
      field: 'status',
      minWidth: 150,
      headerName: 'Task Status',
      renderCell: (params) => {
        if (params.row.wfh_task_approved === 0) {
          return <Chip label="Pending" color="warning" variant="outlined" />;
        } else if (params.row.wfh_task_approved === 1) {
          return <Chip label="Approved" color="success" variant="outlined" />;
        } else if (params.row.wfh_task_approved === 2) {
          return <Chip label="Rejected" color="error" variant="outlined" />;
        } else {
          return 'N/A';
        }
      },
    },
    {
      field: 'regularization',
      flex: 1,
      minWidth: 200,
      headerName: 'Regularization',
      type: 'string',
      headerAlign: 'left',
      align: 'left',
      renderCell: ({ row }) => {
        const date1 = dayjs(row?.hodLastUpdate);
        const today = dayjs();

        const isThisMonth = Boolean(today.format('MM-YYYY') == dayjs(row?.fromDate).format('MM-YYYY'));

        return (
          <Button
            disabled={
              !isThisMonth ||
              !row?.hodRemarks?.startsWith('Bypassed') ||
              row?.hrRemarks?.endsWith('Regularization') ||
              row?.leave_type_id < 0 ||
              row?.hrRemarks?.endsWith('COUNTED')
              // today.diff(date1, 'day') >= 30
            }
            variant="outlined"
            onClick={() =>
              navigate('/employeeservices/attendance-regularization/request', {
                state: { row: row },
              })
            }
          >
            Go to
          </Button>
        );
      },
    },
    {
      field: 'isEditable',
      flex: 1,
      minWidth: 200,
      headerName: 'Actions',
      type: 'string',
      headerAlign: 'left',
      align: 'left',
      renderCell: (params) => LeaveActions(params),
    },
  ];
};
